export const PREVENTIVO = 'PREV'
export const CORRECTIVO = 'CORR'
